import { updateCategoryType } from '@/plugins/dataLayer/utils/index.js';

export default function($store) {
  return {
    // This campaign identifier is temporarily hard-coded. See https://digital.vfc.com/jira/browse/VFDP-87380 for more details
    campaignType: 'main',
    name: 'Randomizer',
    event: {
      name: 'trackEvent',
      nameIframe: 'loadEventData',
      category: 'Customs',
      nonInteractive: false,
      customMetrics: {},
      customVariables: {},
      _clear: true
    },
    types: {
      start: 'start',
      style: 'style',
      shoes : 'Shoes',
      loadMore: 'load more',

      colors: 'colors',
      colorChanges: 'color changes',
      chooseDesign: 'choose design',
      addToCart: 'add to cart',
      customizeFurther: 'customize further'
    },
    labels: {
      closeModal: 'Close Modal',
      backModal: 'Back Modal',
      addToCart: 'Add to Cart',
      customize: 'Customize',
      backpack: 'Backpack',
    },
    /**
     * @function logAnalyticsEvent
     * @description Adds an event to GTM's dataLayer.
     * These events are during the randomizer workflow
     * but share the same formatting. This function is provided for the Randomizer
     * in order to avoid code duplication in the formatting of the GTM events.
     *
     * @param {object} payload
     * MUST have type attribute, to assure the dataLayer event type.
     * MUST have count attribute for colorChanges event, to assure the dataLayer eventLabel.
     * MUST have action attribute for colorChanges event, to assure the dataLayer eventLabel.
     * CAN have eventLabel attribute, to assure the dataLayer eventLabel.
     * @returns {void}
     */
    logAnalyticsEvent: function (payload) {
      let validEvent = true;

      const useEcomDataLayerFormat = $store.getters['utils/useEcomDataLayerFormat'];
      const canvasActive = $store.getters["utils/canvasActive"];
      const data = {
        event: useEcomDataLayerFormat ? this.event.nameIframe : this.event.name,
        eventCategory: this.event.category,
        eventAction: `${ this.campaignType } ${ this.name } ${ payload.type }`
      };

      if (useEcomDataLayerFormat) {
        data.eventAction = payload.eventAction ? payload.eventAction : `${ this.name }`;
        data.nonInteractive = this.event.nonInteractive;
        data.customMetrics = payload.customMetrics ? payload.customMetrics : this.event.customMetrics;
        data.customVariables = payload.customMetrics ? payload.customMetrics : this.event.customVariables;
        data._clear = this.event._clear;

        if ($store.state.randomizer.selectedStyle === 'backpack' || payload.eventLabel === 'backpacks') {
          data.eventAction += ' - Backpack';
        } else {
          data.eventAction += ' - Shoes';
        }

        if(payload.action){
          data.eventAction += ` - ${payload.action}`;
        }

        if (payload.precreatedCustomCode) {
          data.precreatedCustomCode = payload.precreatedCustomCode;
        }
      }

      switch (payload.type) {
        case this.types.start:
          data.eventLabel = payload.eventLabel;
          break;
        case this.types.style:
          data.eventLabel = payload.eventLabel;
          break;
        case this.types.shoes:
          data.eventLabel = payload.eventLabel;
          break;
        case this.types.loadMore:
          break;
        default:
          validEvent = false;
          break;

        case this.types.colors:
          data.eventLabel = payload.eventLabel;
          break;
        case this.types.colorChanges:
          data.eventLabel = payload.count + ' - ' + payload.action; // Examples: "5 - back", "9 - exit"
          break;
        case this.types.chooseDesign:
        case this.types.addToCart:
          data.eventLabel = payload.eventLabel;
          if (payload.precreatedCustomCode) {
            data.precreatedCustomCode = payload.precreatedCustomCode;
          }
          break;
        case this.types.customizeFurther:
          if (payload.precreatedCustomCode) {
            data.precreatedCustomCode = payload.precreatedCustomCode;
          }
        break;
      }

      if (validEvent) {
        try {
          if(canvasActive) parent.dataLayer.push(data);
          else dataLayer.push(data)
        } catch (err) {
          console.error("CORS origin error on datalayer push to parent", err);
        }
      } else {
        console.warn('Randomizer: invalid data layer event: ', data);
      }
    },
    updateCategoryType: updateCategoryType,
  };
};
